







































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class GrAlertBox extends Vue {
  @Prop({ type: String, required: true })
  readonly type!: "accent" | "warning";

  @Prop({ type: Boolean, default: false })
  readonly hideIcon!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly centerContent!: boolean;

  get backgroundColor(): string {
    switch (this.type) {
      case "accent":
        return "accent";
      case "warning":
        return "warning";
    }
  }

  get iconColor(): string {
    switch (this.type) {
      case "accent":
        return "white";
      case "warning":
        return "black";
    }
  }

  get textColorClass(): string {
    switch (this.type) {
      case "accent":
        return "white--text";
      case "warning":
        return "black--text";
    }
  }
}
